import { supabase } from '@/lib/supabase';

export const catalogService = {
  async getCategories() {
    try {
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error fetching categories:', error);
      throw new Error(error?.message || 'Failed to fetch categories');
    }
  },

  async getCategoryBySlug(slug: string) {
    try {
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .eq('slug', slug)
        .single();

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error fetching category:', error);
      throw new Error(error?.message || 'Failed to fetch category');
    }
  },

  async getModelsByCategory(categorySlug: string) {
    try {
      const { data, error } = await supabase
        .from('models')
        .select('*')
        .eq('category_slug', categorySlug)
        .order('name', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error fetching models:', error);
      throw new Error(error?.message || 'Failed to fetch models');
    }
  },

  async getModelsBySubcategory(categorySlug: string, subcategory: string) {
    try {
      const { data, error } = await supabase
        .from('models')
        .select('*')
        .eq('category_slug', categorySlug)
        .eq('subcategory', subcategory)
        .order('name', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error fetching models by subcategory:', error);
      throw new Error(error?.message || 'Failed to fetch models');
    }
  },

  async getModelById(id: string) {
    try {
      const { data, error } = await supabase
        .from('models')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error fetching model:', error);
      throw new Error(error?.message || 'Failed to fetch model');
    }
  }
};